import AxiosManager from "../_axiosManager";

export async function putMembershipPrice(body: any) {
  const res = await AxiosManager.getInstance().put("/admin/membership", body);

  return res;
}
